
import React from 'react';
import { Route } from 'react-router-dom';
import { AuthPaymentProtectedRoute } from './AuthPaymentProtectedRoute';

// Courier pages
import CourierDashboard from '@/pages/courier/CourierDashboard';
import CourierProfile from '@/pages/courier/CourierProfile';
import CourierLocationHistory from '@/pages/courier/CourierLocationHistory';
import CourierPayments from '@/pages/courier/CourierPayments';
import CourierSubscriptionsPage from '@/pages/courier/SubscriptionsPage';
import CourierRentalsHistoryPage from '@/pages/courier/CourierRentalsHistoryPage';
import MySim from '@/pages/courier/MySim';
import TariffPage from '@/pages/courier/TariffPage';

/**
 * Компонент, содержащий все маршруты для курьера
 * @param isAuthenticated - флаг, указывающий, аутентифицирован ли пользователь
 */
export const CourierRoutes: React.FC<{ isAuthenticated: boolean }> = ({ isAuthenticated }) => {
  return (
    <>
      <Route path="/courier" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <CourierDashboard />
        </AuthPaymentProtectedRoute>
      } />

      <Route path="/courier/profile" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <CourierProfile />
        </AuthPaymentProtectedRoute>
      } />

      <Route path="/courier/payments" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <CourierPayments />
        </AuthPaymentProtectedRoute>
      } />

      <Route path="/courier/location-history" element={
        <AuthPaymentProtectedRoute 
          isAllowed={isAuthenticated} 
          redirectPath="/login"
          bypassAuthCheck={true}
        >
          <CourierLocationHistory />
        </AuthPaymentProtectedRoute>
      } />
      
      <Route path="/courier/subscriptions" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <CourierSubscriptionsPage />
        </AuthPaymentProtectedRoute>
      } />
      
      <Route path="/courier/rentals-history" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <CourierRentalsHistoryPage />
        </AuthPaymentProtectedRoute>
      } />
      
      <Route path="/courier/mysim" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <MySim />
        </AuthPaymentProtectedRoute>
      } />

      <Route path="/courier/tariff" element={
        <AuthPaymentProtectedRoute isAllowed={isAuthenticated} redirectPath="/login">
          <TariffPage />
        </AuthPaymentProtectedRoute>
      } />
    </>
  );
};
